import { ROUTES } from '@/constants/routes';
import { TeammateDetails } from '@/types/teammates';
import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '../core';

type TeammateDetailsViewProps = {
  teammateDetails: TeammateDetails;
};

export default function TeammateDetailsView({
  teammateDetails,
}: TeammateDetailsViewProps) {
  const { uuid, aggNumbers } = teammateDetails;

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        View
      </Typography>
      <Stack spacing={2}>
        <SVLink to={`${ROUTES.CUSTOMERS}?teammate_id=${uuid}`}>
          Associated Customers ({aggNumbers.customers || 0})
        </SVLink>
        <SVLink to={`${ROUTES.BUSINESSES}?teammate_id=${uuid}`}>
          Associated Businesses ({aggNumbers.businesses || 0})
        </SVLink>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}?teammate_id=${uuid}`}>
          Active Bank Accounts ({aggNumbers.bankAccounts || 0})
        </SVLink>
        <SVLink
          to={`${ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT}?teammate_id=${uuid}`}>
          Draft Bank Applications ({aggNumbers.draftBankApplications || 0})
        </SVLink>
      </Stack>
    </Card>
  );
}
